module.exports = __webpack_public_path__ + "static/img/chai.9872d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skills/chai.png
// module id = 513
// module chunks = 1